export const genericSondage = [
    {
        question : "Qui est l'homme du match ?",
        choices : (match) => getMatchPlayers(match),
    },
    {
        question : "Quelle a été la meilleure équipe ?",
        choices : (match) => [match.homeTeam, match.awayTeam]
    },
    {
        question : "Quel résultat attendez-vous pour ce match ?",
        choices : (match) => ['Victoire de '+match.homeTeam.name, 'Match nul', 'Victoire de '+match.awayTeam.name]
    }
]


// Utils
export const getMatchPlayers = (match) => {

    if(match.homeHolders.length > 0 && match.awayHolders.length > 0)
        return match.homeHolders.concat(match.homeSubstitutes).concat(match.awayHolders).concat(match.awaySubstitutes)

    return match.homeTeam.players.concat(match.awayTeam.players).sort((a,b) => a.lastname.localeCompare(b.lastname))
}

// Utils
export const getMatchTeams = (match) => {

    return [match.homeTeam,match.awayTeam] .concat(match.homeSubstitutes).concat(match.awayHolders).concat(match.awaySubstitutes)
}